import React, { useState } from 'react';
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem';
import { FormWrapper } from './Wrappers';
import { Responsible, Role } from './Types';
import { apiSetResponsible } from './Api';
import { addToCallChain } from './CallCenter';
import { selfLabel, useActiveRoleName } from './ActiveRole';

function ResponsibleSelectRaw({value, currentDraftId, otherRoles, onChangeResponsible, ...props}: {
  value: Responsible,
  currentDraftId: string,
  otherRoles: Role[],
  onChangeResponsible: (newResponsible: Responsible) => void,
  sx: {},
  error: boolean,
  disabled: boolean
}) {

    const [disabled, setDisabled] = useState(false)
    // 'myself' is what goes on the wire (the server resolves it to the acting role); the menu says
    // which role that is, so the item reads like the others in the list.
    const selfName = useActiveRoleName()

    function setResponsible(newResponsible: Responsible) {
      const previous = value  // revert target if this (should-never-fail) write fails anyway
      setDisabled(true)
      onChangeResponsible(newResponsible)  // optimistic — the dropdown reflects the choice at once
      addToCallChain(
        async () => {
          try {
            await apiSetResponsible({'draft_id': currentDraftId, 'responsible': newResponsible})
          } catch {
            onChangeResponsible(previous)  // snap back; the error is already on the bus (parseResponse)
          } finally {
            setDisabled(false)  // always re-enable, success or failure
          }
        },
        false
      )
    }

    return (
      <Select {...props} disabled={disabled} value={value} autoWidth={true} onChange={e => setResponsible(e.target.value)}>
        <MenuItem value="no_idea"></MenuItem>
        <MenuItem value="myself">{selfLabel(selfName)}</MenuItem>
        <MenuItem value="someone_else">Någon annan</MenuItem>
        {otherRoles.map((role) => <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>)}
      </Select>
    )
}

const ResponsibleSelect = FormWrapper({Component: ResponsibleSelectRaw})

export default ResponsibleSelect
